import { combineReducers } from 'redux';
import globalReducer from './global';
import companyReducer from './company';
import kioskReducer from './kiosk';
import surveyReducer from './survey';
import questionsReducer from './questions';
import answersReducer from './answers';
import languagesReducer from './languages';

const appReducer = combineReducers({
  global: globalReducer,
  company: companyReducer,
  kiosk: kioskReducer,
  survey: surveyReducer,
  questions: questionsReducer,
  answers: answersReducer,
  languages: languagesReducer,
});

export default appReducer;
